export const TEAM = [
    { displayName: "Benjamin Fife", email: "bfife@chicagoventure.com" },
    { displayName: "Chris Stalcup", email: "cstalcup@chicagoventure.com" },
    { displayName: "Coby Neuenschwander", email: "coby@chicagoventure.com" },
    { displayName: "Eleanor Henricksen", email: "ehenricksen@chicagoventure.com" },
    { displayName: "Joe Gemino", email: "jgemino@chicagoventure.com" },
    { displayName: "John Fife", email: "jfife@chicagoventure.com" },
    { displayName: "Josephine Xu", email: "jxu@chicagoventure.com" },
    { displayName: "JP Lefgren", email: "jlefgren@chicagoventure.com" },
    { displayName: "Julian Fife", email: "julian@chicagoventure.com" },
    { displayName: "Leo Hansen", email: "lhansen@chicagoventure.com" },
    { displayName: "Su Nandar", email: "snandar@chicagoventure.com" },
    { displayName: "Will Li", email: "wli@chicagoventure.com" },
];
/**
 * Merges the hardcoded seed with a live directory (e.g. pipeline-users),
 * deduped by email (live entry wins), sorted by display name. Excludes
 * julianfife.com aliases so people don't appear twice.
 */
export function mergeDirectory(live) {
    const byEmail = new Map();
    for (const t of TEAM)
        byEmail.set(t.email.toLowerCase(), t);
    for (const u of live) {
        const email = u.email?.toLowerCase();
        if (!email || !email.endsWith("@chicagoventure.com"))
            continue;
        byEmail.set(email, {
            displayName: u.displayName || email,
            email,
            photoURL: u.photoURL ?? null,
        });
    }
    return [...byEmail.values()].sort((a, b) => a.displayName.localeCompare(b.displayName));
}
/**
 * Resolves a pipeline-deals contact field against a directory. The CRM
 * stores admin-configurable SHORT LABELS (defaults "Ben", "Joe", "Su"),
 * comma- or ampersand-separated; only the first listed name is resolved.
 *
 * Resolution order, all case-insensitive — kept identical to the CRM's
 * `src/utils/researchContactLookup.js`, which is what the "create closing
 * checklist" toast uses to tell the user who will be assigned. If the two
 * ever diverge, the toast promises an assignee the backend never sets
 * (that is exactly how "Ben" silently failed against "Benjamin Fife").
 *
 *   1. Exact display name            ("Su Nandar" → Su Nandar)
 *   2. Display name starts "{label} " ("Su" → Su Nandar)
 *   3. First-name prefix either way   ("Ben" → Benjamin Fife,
 *                                      "Benjamin" → Benjamin Fife)
 *   4. null — caller leaves the item unassigned
 *
 * Steps 2 and 3 require a unique match: a label like "Jo" that prefixes
 * Joe, John and Josephine, or "Joe" when two Joes are in the directory,
 * resolves to nobody rather than to whichever sorts first, since a
 * checklist assignment is sticky once written.
 */
export function resolveContact(contactField, directory = TEAM) {
    if (!contactField)
        return null;
    const label = contactField.split(/[,&]/)[0]?.trim().toLowerCase();
    if (!label)
        return null;
    const exact = directory.find((t) => t.displayName.toLowerCase() === label);
    if (exact)
        return exact;
    // Both prefix steps require a unique match: the live directory can hold
    // two people who share a first name, and "Joe" must then assign nobody.
    const prefixed = directory.filter((t) => t.displayName.toLowerCase().startsWith(label + " "));
    if (prefixed.length === 1)
        return prefixed[0];
    if (prefixed.length > 1)
        return null;
    const byFirstName = directory.filter((t) => {
        const first = t.displayName.split(/\s+/)[0]?.toLowerCase() ?? "";
        return first.length > 0 && (first.startsWith(label) || label.startsWith(first));
    });
    return byFirstName.length === 1 ? byFirstName[0] : null;
}
